import React from "react";
import { UserSelectDropdown } from "./UserSelectDropdown";
import { DatePicker } from "./DatePicker";
import { RecurrencePicker } from "./RecurrencePicker";

/**
 * TaskInlineMetaBar
 * Renders due date, assignee, priority, status, and recurrence controls for inline task creation.
 */
export function TaskInlineMetaBar({
  newDueDate,
  onChangeDueDate,
  users = [],
  newAssigneeUid,
  onChangeAssigneeUid,
  newPriority,
  onChangePriority,
  newStatus,
  onChangeStatus,
  newRecurrence,
  onChangeRecurrence,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 pt-2 border-t border-gray-50">
      {/* Due Date Input */}
      <div className="flex items-center gap-1">
        <span className="text-[10px] font-bold text-gray-400 uppercase">
          Due:
        </span>
        <DatePicker
          value={newDueDate}
          onChange={(val) => onChangeDueDate(val || "")}
        />
      </div>

      {/* Assignee Input */}
      <div className="flex items-center gap-1">
        <span className="text-[10px] font-bold text-gray-400 uppercase">
          Assignee<span className="text-red-500">*</span>:
        </span>
        <UserSelectDropdown
          users={users}
          value={newAssigneeUid}
          onChange={onChangeAssigneeUid}
        />
      </div>

      {/* Priority Input */}
      <div className="flex items-center gap-1">
        <span className="text-[10px] font-bold text-gray-400 uppercase">
          Priority:
        </span>
        <select
          value={newPriority}
          onChange={(e) => onChangePriority(e.target.value)}
          className="border border-gray-200 rounded px-2 py-1 text-xs text-gray-600 focus:outline-none focus:ring-1 focus:ring-gray-300"
        >
          <option value="Low">🟢 Low</option>
          <option value="Medium">🟡 Medium</option>
          <option value="High">🔴 High</option>
        </select>
      </div>

      {/* Status Input */}
      <div className="flex items-center gap-1">
        <span className="text-[10px] font-bold text-gray-400 uppercase">
          Status:
        </span>
        <select
          value={newStatus}
          onChange={(e) => onChangeStatus(e.target.value)}
          className="border border-gray-200 rounded px-2 py-1 text-xs text-gray-600 focus:outline-none focus:ring-1 focus:ring-gray-300"
        >
          <option value="Open">Open</option>
          <option value="In Progress">In Progress</option>
          <option value="On Hold">On Hold</option>
          <option value="Closed">Closed</option>
        </select>
      </div>

      {/* Recurrence Input */}
      <div className="flex items-center gap-1">
        <RecurrencePicker
          value={newRecurrence}
          onChange={onChangeRecurrence}
        />
      </div>
    </div>
  );
}
